<template>
  <div class="page">
    <div id="action-bar">
      <input type="search" v-model="query" placeholder="Search" />
      <StatusFilterToggle v-model="statusFilter" />
    </div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Kit</th>
          <th>Markers</th>
          <th>Client</th>
          <th>Created</th>
          <th>Updated</th>
          <th>Status</th>
          <th class="col-billed">Cost</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(test, index) in testSearch"
          :key="'test' + index"
          @click="addPanel('panel-view-test', { testId: test.id })"
        >
          <td><v-icon name="cube" /></td>
          <td>{{ test.kit.name }}</td>
          <td>{{ kitMarkers(test.kit.markers).join(", ") }}</td>
          <td>{{ test.client.name }}</td>
          <td>{{ test.created | date }}</td>
          <td>{{ test.updated | date }}</td>
          <td>
            <TestStatus :status="test.status" />
          </td>
          <td class="col-billed">
            <div :class="{ billed: test.billed }">
              <v-icon name="check" v-if="test.billed" />{{
                test.kit.cost | money
              }}
            </div>
          </td>
          <!--
          <td>
            <button
              @click.stop="addPanel('panel-edit-test', test.id)"
              class="outline"
            >
              <v-icon name="pencil-alt" />
            </button>
          </td>
          -->
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="9">
            <div class="test-cost-totals">
              <div>Billed: {{ totalBilled(true) | money }}</div>
              <div>Not billed: {{ totalBilled(false) | money }}</div>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
    <PanelViewTest />
    <PanelEditTest />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TestStatus from "@/components/TestStatus";
import PanelViewTest from "@/components/PanelViewTest";
import PanelEditTest from "@/components/PanelEditTest";
import StatusFilterToggle from "@/components/StatusFilterToggle";

export default {
  name: "Tests",
  data() {
    return {
      query: "",
      statusFilter: null
    };
  },
  components: {
    TestStatus,
    PanelViewTest,
    PanelEditTest,
    StatusFilterToggle
  },
  methods: {
    kitMarkers(markers) {
      return Object.keys(markers).map(marker => markers[marker].title);
    },
    totalBilled(billed) {
      return this.testSearch.reduce((total, currentTest) => {
        if (currentTest.billed === billed) return currentTest.kit.cost + total;
        return total;
      }, 0);
    }
  },
  computed: {
    ...mapState("TestsStore", ["tests"]),
    ...mapState("TestsStore", ["statusTypes"]),
    testSearch() {
      // if (this.query === "") return this.tests;
      const queryLowerCase = this.query.toLowerCase();
      return this.tests
        .filter(test => {
          return (
            test.kit.name.toLowerCase().indexOf(queryLowerCase) > -1 ||
            test.client.name.toLowerCase().indexOf(queryLowerCase) > -1
          );
        })
        .filter(
          test => !this.statusFilter || test.status === this.statusFilter
        );
    }
  },
  mounted() {
    this.$store.dispatch("TestsStore/subscribe");
  },
  beforeDestroy() {
    this.$store.dispatch("TestsStore/unsubscribe");
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

.col-billed {
  text-align: right;
  div {
    svg {
      margin-right: 0.25em;
    }
    &.billed {
      opacity: 0.5;
    }
  }
}

tfoot {
  text-align: right;
}
</style>
